import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import { percentageFilter } from "app/filters/ngFilters";
import { EMPTY_LINE_DATA_CONFIG, gradientDefault } from "app/pages/activation/components/Shared/LineChart/configs";
import { LineChart } from "app/pages/activation/components/Shared/LineChart/LineChart";
import { addPercentPoint } from "app/pages/activation/helpers/format";
import { DEFAULT_DECIMAL, FORMATTERS } from "app/common/benchmark/formatters";

import { CHART_HEIGHT, EMPTY_DIFFERENCE, TIME_PERIOD } from "./constants";
import * as SC from "./styles";

const Empty = () => (
    <SC.Container>
        <SC.MetricRow>
            <SC.Share>{FORMATTERS.percentSign(EMPTY_DIFFERENCE, DEFAULT_DECIMAL)}</SC.Share>
        </SC.MetricRow>
        <SC.Difference>
            <ChangeIndication
                className="customChangeIndication"
                changeValue={`${addPercentPoint(percentageFilter()(EMPTY_DIFFERENCE, 2))} ${TIME_PERIOD}`}
                isIncreasing
                isNotChanged={false}
            />
        </SC.Difference>
        <SC.ChartContainer>
            <LineChart
                gradient={gradientDefault}
                height={CHART_HEIGHT}
                data={EMPTY_LINE_DATA_CONFIG}
                tooltipEnabled={false}
            />
        </SC.ChartContainer>
    </SC.Container>
);

export default Empty;
